import React, { ReactNode } from "react";

import { useAuth } from "../../context";

export const Restricted: React.FC<React.PropsWithChildren<{ fallback?: ReactNode; permits: string[] }>> = ({
  fallback,
  permits,
  children,
}) => {
  const [{ isPermitted }] = useAuth();
  return isPermitted(permits) ? <>{children}</> : <>{fallback}</>;
};
